import { useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { categories } from "@/mocks/categories";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const category = categories.find((c) => c.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  if (!category) {
    return (
      <>
        <SEO title="分类未找到" description="抱歉，你查找的分类不存在。" />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="pt-20 pb-16 px-4 md:px-6 text-center">
            <h1 className="text-2xl font-heading text-foreground-900">分类未找到</h1>
            <Link to="/" className="text-primary-500 mt-4 inline-block">返回首页</Link>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      <SEO
        title={`${category.name} - 黑料吃瓜在线观看`}
        description={`黑料吃瓜网${category.name}分类，汇集最新最热${category.name}相关视频内容，高清在线播放，每日更新。`}
        keywords={`${category.name},黑料吃瓜,吃瓜视频,在线观看`}
        canonicalUrl={`https://wx1121.cn/category/${slug}`}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category.name },
              ]}
            />

            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500">
                <i className={`${category.icon} text-3xl`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500 mb-8">
                该分类共有 {category.count} 条内容，页面正在建设中...
              </p>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                返回首页
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}